import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/lib/legal-content";

export const Route = createFileRoute("/acceptable-use")({
  component: AUPPage,
  head: () => ({
    meta: [
      { title: "Acceptable Use Policy — CoderLity" },
      { name: "description", content: "What's allowed and not allowed on CoderLity hosting, software and platform services." },
      { property: "og:url", content: "/acceptable-use" },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/acceptable-use" }],
  }),
});

function AUPPage() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Acceptable Use Policy"
      sub="Rules for using our hosting and platform services."
      updated="May 1, 2026"
      sections={[
        { heading: "Prohibited content", body: "No malware, phishing, CSAM, hate speech, terrorism, unlicensed pharmaceuticals or content that violates applicable law." },
        { heading: "Prohibited activities", body: "No spam, unsolicited bulk email, DDoS, brute-force, cryptomining without prior approval, or any activity that harms our infrastructure or other customers." },
        { heading: "Copyright & IP", body: "Do not host or distribute content you don't own or license. See our DMCA policy for takedown procedures." },
        { heading: "Fair use", body: "Resource limits apply. Sustained CPU/RAM/IO abuse of shared resources will be throttled or suspended with 24-hour notice where possible." },
        { heading: "Enforcement", body: "Violations may result in warning, suspension or termination without refund. Serious violations are reported to relevant authorities." },
        { heading: "Reporting abuse", body: "Report violations to abuse@coderlity.com with URLs, timestamps and evidence." },
      ]}
    />
  );
}
